import {
  Component,
  EventEmitter,
  Input,
  Output,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { FormGroup, Validators } from '@angular/forms';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { lastValueFrom } from 'rxjs';
import { ProjectItem, OutlineItem } from 'src/app/shared/models/base.models';
import { ApiService } from 'src/app/shared/services/api.service';
import { CreateWalletDto } from './dto/create-wallet.dto';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-create-space-wallet-modal',
  templateUrl: './create-space-wallet-modal.component.html',
  styleUrls: ['./create-space-wallet-modal.component.css'],
})
export class CreateSpaceWalletModalComponent {
  form = new FormGroup({});
  model = {};
  fields: FormlyFieldConfig[] = [
    {
      key: 'name',
      type: 'input',
      props: {
        attributes: {
          class: 'form-control form-control-solid form-control-lg',
        },
        label: 'Wallet Name',
        placeholder: 'Name your wallet',
        required: true,
      },
    },
    {
      key: 'balance',
      type: 'number',
      validators: [Validators.max(-1)],
      props: {
        attributes: {
          class: 'form-control form-control-solid form-control-lg',
        },
        label: 'Wallet Balance',
        placeholder: 'Enter your initial balance',
        required: true,
        min: 0,
      },
    },
    {
      key: 'currency_id',
      type: 'system-currency',
      props: {
        label: 'Wallet Currency',
        placeholder: 'Select Currency',
        required: true,
        min: 0,
      },
    },
    {
      key: 'description',
      type: 'textarea',
      props: {
        attributes: {
          class: 'form-control form-control-solid form-control-lg h-100px',
        },
        label: 'Description',
        placeholder: 'Write a Description (optional)',
        required: false,
      },
    },
  ];

  @ViewChild('walletCreationModal') modalContent: TemplateRef<any>;
  @Input() modalRef: NgbModalRef;

  @Input() space: ProjectItem;

  @Input('opener') set modalOpener(value: boolean) {
    if (!!value) {
      this.open();
    }
  }

  @Output() openerChange = new EventEmitter<boolean>();

  @Output() itemCreated = new EventEmitter<OutlineItem>();

  constructor(
    private api: ApiService,
    private modalService: NgbModal,
    private toastr: ToastrService
  ) {}

  async onSubmit(data) {
    // console.log(data);
    this.form.markAllAsTouched();
    if (this.form.valid) {
      // Check if the form is valid
      let newWalletPayload: CreateWalletDto = {
        name: data.name,
        balance: data.balance,
        currency_id: data.currency_id,
        description: data.description,
      };
      let newWallet = await this.createSpaceWallet(
        this.space.id,
        newWalletPayload
      );
      this.closeModal();
      this.itemCreated.emit(newWallet);
    } else {
      this.toastr.error(
        'Please fill out all required fields before submitting.'
      );
    }
  }

  async createSpaceWallet(
    spaceId: number = this.space.id,
    payload: CreateWalletDto
  ) {
    let request$ = this.api.createSpaceWallet(spaceId, payload);
    let response = await lastValueFrom(request$);

    console.log(response);
    return response;
  }
  resetEverything() {}

  closeModal() {
    this.modalRef.dismiss();
    this.openerChange.emit(false);
  }

  async onOpenModal() {
    this.resetEverything();
  }

  // Modal Open
  async open(content?) {
    this.onOpenModal();
    this.modalRef = this.modalService.open(this.modalContent, {
      ariaLabelledBy: 'modal-basic-title',
      size: 'lg',
      backdrop: 'static',
      centered: true,
      animation: true,
      windowClass: 'global-modal-class modal-animate-in',
    });
  }
}
